module.exports = __webpack_public_path__ + "static/media/img-contact-placeholder.6988f7c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-contact-placeholder.svg
// module id = 84
// module chunks = 14